import { Stack } from '@mui/material';

import clsx from 'clsx';

import RadioGroup from '../../../../components/HookFormControls/RadioGroup';
import { ClassListItem } from '../../../../db/classes/types';
import NoClasses from '../../../class/NoClasses';
import { FormValues } from '../types';
import Skeleton from './Skeleton';
import { ClassCard, classListClasses, RadioOption } from './styles';
import useClassList, { UseClassList } from './vm';
import { CourseListItem } from '../../../../db/courses/types';

export interface ClassListProps<T extends FormValues> extends UseClassList<T> {
  isLoading: boolean;
  selectedCourse: CourseListItem;
  classes: ClassListItem[];
  className?: string;
}

const ClassList = <T extends FormValues>({
  isLoading,
  selectedCourse,
  classes,
  className,
  ...vmProps
}: ClassListProps<T>) => {
  const { control, name } = vmProps;
  const { selectedClassId } = useClassList(vmProps);

  if (isLoading) {
    return <Skeleton />;
  }

  if (classes.length === 0) {
    return <NoClasses selectedCourse={selectedCourse} className={className} />;
  }

  return (
    <RadioGroup control={control} name={name} fullWidth className={className}>
      <Stack gap={1.5} px={2} py={0.5} my={-0.5} maxWidth="100%">
        {classes.map((cls) => (
          <RadioOption key={cls.classId} value={cls.classId}>
            <ClassCard
              {...cls}
              type="activities"
              className={clsx(classListClasses.classCard, {
                [classListClasses.selectedClass]: cls.classId === selectedClassId,
              })}
            />
          </RadioOption>
        ))}
      </Stack>
    </RadioGroup>
  );
};

export default ClassList;
